import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Document, Invoice } from '../../models/invoice';
import { Company } from '../../models/company';
import { HeaderData } from '../../models/headerData';
import { SupplierFeatures } from '../../models/supplierFeatures';
import { DocPendientesDigitalizar } from '../../models/docPendientesDigitalizar';
import { FiltroDocsResult } from '../../models/filtroDocsResult';
import { PredictionsObj } from '../../models/predictions';
import { UsuarioDIEZdesplegable } from 'src/app/models/usuariosDIEZdesplegable';
import { ConsultaTercerosInvoicer } from '../../models/tercero';
import { SepararRevision } from '../../models/RevisionSeparar';
import { PendingDocument } from 'src/app/shared/models/pending-document.model';
import { ObservacionesSecundario } from 'src/app/models/observacionesSecundario';
import { ListaFiltroSecunPrin } from 'src/app/models/listaFiltroSecunPrin';



@Injectable({
  providedIn: 'root'
})
export class InvoiceService {

  private storageKey = 'sdmInvoicerCurrentUser';

  constructor(private http: HttpClient) { }

  private GetQuery(query: string): any {

    const url = `${environment.apiUri}api/${query}`;

    return this.http.get<any>(url);
  }

  private handleError(err: HttpErrorResponse) {

    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {

      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      switch (err.status) {
        case 402:
          errorMessage = 'No se puede procesar este documento debido a que el cliente no tiene saldo.';
          break;
        case 400:
        case 401:
        case 403:
        case 404:
        case 405:
          errorMessage = 'No hay facturas pendientes de introducir.';
          break;
        case 500:
        case 501:
        case 502:
        case 503:
        case 504:
        case 505:
          errorMessage = 'Ocurrió un error al recuperar la información de la siguiente factura.';
          break;
        default:
          errorMessage = `Error: ${err.status}, mensaje: ${err.message}`;
          break;
      }
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }

  getNextInvoice(user: string, valorEstadoNEXT: number, valorSecPrinNEXT: string, valorTipoNEXT: number, valorFechaFiltro: number, filtroUsuSUPER: number, valorFiltroCIF: string): Observable<Document> {

    var storageUser = JSON.parse(localStorage.getItem(this.storageKey));
    var usuariosExcluir: string = (storageUser.ignorarCliente != null && storageUser.ignorarCliente != undefined && storageUser.ignorarCliente != "" && storageUser.ignorarCliente != " ") ? storageUser.ignorarCliente : "vacio";


    return this.http.get<any>(`${environment.apiUri}api/documents/nextToInvoice/${user}/${valorEstadoNEXT}/${valorSecPrinNEXT}/${valorTipoNEXT}/${valorFechaFiltro}/${usuariosExcluir}/${filtroUsuSUPER}/${valorFiltroCIF}`)
      .pipe(map(invoice => {
        return invoice;
      }), catchError(this.handleError));
  }

  cargarDocSelecc(user: string, id: string): Observable<Document> {
    return this.http.get<any>(`${environment.apiUri}api/documents/cargarDocSelecc/${user}/${id}`)
      .pipe(map(invoice => {
        return invoice;
      }), catchError(this.handleError));
  }

  getCompany(cif: string): Observable<Company> {
    return this.http.get<any>(`${environment.apiUri}api/companies/${cif}`)
      .pipe(map(company => {
        return company;
      }), catchError(this.handleErrorCif));
  }

  private handleErrorCif(err: HttpErrorResponse) {

    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {

      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      switch (err.status) {
        case 400:
        case 401:
        case 402:
        case 403:
        case 404:
        case 405:
          errorMessage = 'C.I.F./N.I.F. no encontrado.';
          break;
        case 500:
        case 501:
        case 502:
        case 503:
        case 504:
        case 505:
          errorMessage = 'Ocurrió un error al solicitar la información.';
          break;
        default:
          errorMessage = `Error: ${err.status}, mensaje: ${err.message}`;
          break;
      }
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }

  postInvoice(invoice: Invoice, observacionesINTERNAS: string): Observable<Invoice> {
    let header = new HttpHeaders({ 'content-type': 'application/json' });

    return this.http.post<Invoice>(`${environment.apiUri}api/documents/invoice`, { invoice, observacionesINTERNAS }, { headers: header })
      .pipe(map(responseInvoice => {
        return responseInvoice;
      }), catchError(this.handleErrorPostInvoice));
  }

  pasarDocuConDatosAsupervision(idDoc: number) {

    return this.http.get<any>(`${environment.apiUri}api/documents/pasarDocuConDatosAsupervision/${idDoc}`)
      .pipe(map(resultado => {
        return resultado;
      }),
        catchError((error, captura) => {
          console.log(error);
          //return null;
          throw error;
        })
      );
  }

  private handleErrorPostInvoice(err: HttpErrorResponse) {

    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {

      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      switch (err.status) {
        case 400:
        case 401:
        case 402:
        case 403:
        case 404:
        case 405:
          errorMessage = 'La factura no se ha podido grabar. Tiene datos duplicados o ya fue grabada anteriormente...';
          break;
        case 500:
        case 501:
        case 502:
        case 503:
        case 504:
        case 505:
          errorMessage = 'Ocurrió un error al grabar la información de la factura.';
          break;
        default:
          errorMessage = `Error: ${err.status}, mensaje: ${err.message}`;
          break;
      }
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }

  generarMetadatosInc(datos: string, idDocumento, usuarioQueProcesoFactura: string, usuarioActual: string): Observable<Document> {

    usuarioQueProcesoFactura = btoa(usuarioQueProcesoFactura);

    let header = new HttpHeaders({ 'content-type': 'application/json' });

    return this.http.put<any>(`${environment.apiUri}api/documents/putMetadatosInvoice/${idDocumento}/${usuarioQueProcesoFactura}/${usuarioActual}`, { datos: datos }, { headers: header })
      .pipe(map(invoice => {
        return invoice;
      }),

        catchError((error, captura) => {

          console.log(error);



          return null;

        })



        //catchError(this.handleErrorMetaData

      );

  }

  private handleErrorMetaData(err: HttpErrorResponse) {

    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {

      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      switch (err.status) {
        case 400:
        case 401:
        case 402:
        case 403:
        case 404:
        case 405:
          errorMessage = 'No se ha podido introducir la incidencia en los metadatos del documento.';
          break;
        case 500:
        case 501:
        case 502:
        case 503:
        case 504:
        case 505:
          errorMessage = 'Ocurrió un error al recuperar la información del documento.';
          break;
        default:
          errorMessage = `Error: ${err.status}, mensaje: ${err.message}`;
          break;
      }
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }

  GetAvailableById(idPrincipal: number): Observable<number> {


    return this.http.get<any>(`${environment.apiUri}api/Compras/disponible/${idPrincipal}`)
      .pipe(map(disponible => {

        return disponible;
      }),

        catchError((error, captura) => {

          console.log(error);



          return null;

        })

      );

  }

  SaveOrUpdateDatosEmpresa(company: Company): Observable<boolean> {

    return this.http.post<any>(`${environment.apiUri}api/Companies/actualizarDatosEmpresa/${company.id}`, company);
  }

  private handleErrorPutEmpresa(err: HttpErrorResponse) {

    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {

      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      switch (err.status) {
        case 400:
        case 401:
        case 402:
        case 403:
        case 404:
        case 405:
          errorMessage = 'No hay empresas pendientes de actualizar.';
          break;
        case 500:
        case 501:
        case 502:
        case 503:
        case 504:
        case 505:
          errorMessage = 'Ocurrió un error al grabar la información de la empresa.';
          break;
        default:
          errorMessage = `Error: ${err.status}, mensaje: ${err.message}`;
          break;
      }
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }

  marcarDocumentoParaNEXT(idDocumento: number, usuarioQueProcesoFactura: string): Observable<Document> {

    if (usuarioQueProcesoFactura == "") { usuarioQueProcesoFactura = "vacia"; }

    usuarioQueProcesoFactura = btoa(usuarioQueProcesoFactura);

    let ruta: string = `${environment.apiUri}api/documents/pasarASiguienteDOC/${idDocumento}/${usuarioQueProcesoFactura}`;

    return this.http.put<any>(ruta, {})
      .pipe(map(respuestaUpdate => {
        return respuestaUpdate;
      }), catchError(this.handleErrorMarcaDocNEXT));


  }

  private handleErrorMarcaDocNEXT(err: HttpErrorResponse) {

    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {

      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      switch (err.status) {
        case 400:
        case 401:
        case 402:
        case 403:
        case 404:
        case 405:
          errorMessage = 'No hay ningun documento que saltar...';
          break;
        case 500:
        case 501:
        case 502:
        case 503:
        case 504:
        case 505:
          errorMessage = 'Ocurrió un error al intentar saltar el documento.';
          break;
        default:
          errorMessage = `Error: ${err.status}, mensaje: ${err.message}`;
          break;
      }
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }

  obtenerDatosCabeceraInit(idSecundario: string, idPrincipal: string): Observable<HeaderData> {

    return this.http.get<any>(`${environment.apiUri}api/Companies/${idSecundario}/${idPrincipal}`)
      .pipe(map(datos => {

        return datos;
      }),

        catchError((error, captura) => {

          console.log(error);



          //return null;
          throw error;

        })

      );
  }

  getDatosProveedor(cifProveedor: string): Observable<SupplierFeatures> {

    return this.http.get<any>(`${environment.apiUri}api/companies/datosProveedor/${cifProveedor}`)
      .pipe(map(datosProveedor => {

        return datosProveedor;

      }), catchError(this.handleErrorDatosProveedor));
  }

  private handleErrorDatosProveedor(err: HttpErrorResponse) {

    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {

      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      switch (err.status) {
        case 400:
        case 401:
        case 402:
        case 403:
        case 404:
        case 405:
          errorMessage = 'Datos no encontrados utilizando ese CIF/NIF.';
          break;
        case 500:
        case 501:
        case 502:
        case 503:
        case 504:
        case 505:
          errorMessage = 'Ocurrió un error al solicitar la información.';
          break;
        default:
          errorMessage = `Error: ${err.status}, mensaje: ${err.message}`;
          break;
      }
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }

  existeFacturaIntroducidaDeClienteProveedor(estamosRevisando: boolean, secundario: string, tipoDocumento: number, cif: string, numFactura: string, idDocumentoActual: number, fechaFactura: number): Observable<any> {

    // numFactura = btoa(numFactura);
    numFactura = btoa(unescape(encodeURIComponent(numFactura)));
    console.log("//////////////////////");
    console.log("Estamos revisando: " + estamosRevisando);
    console.log("Secundario: " + secundario);
    console.log("Tipo de documento: " + tipoDocumento);
    console.log("CIF/NIF: " + cif);
    console.log("Numero factura: " + numFactura);
    console.log("ID documento actual: " + idDocumentoActual);
    console.log("//////////////////////");

    return this.http.get<any>(`${environment.apiUri}api/documents/comprobacionFacturaExist/${estamosRevisando}/${secundario}/${tipoDocumento}/${cif}/${numFactura}/${idDocumentoActual}/${fechaFactura}`)
      .pipe(map(datosDocMec => {

        return datosDocMec;
      }),
        catchError((error, captura) => {
          console.log(error);
          return null;
        })
      );
  }

  obtenerContadores(): Observable<any> {

    var value = JSON.parse(localStorage.getItem(this.storageKey));
    var soloCliente = "vacio";

    if (value.facturasCliente) {
      soloCliente = value.facturasCliente;
    }
    var usuariosExcluir: string = (value.ignorarCliente != null && value.ignorarCliente != undefined && value.ignorarCliente != "" && value.ignorarCliente != " ") ? value.ignorarCliente : "vacio";

    return this.http.get<any>(`${environment.apiUri}api/documents/obtenerContadores/${soloCliente}/${usuariosExcluir}/${value.email}`)
      .pipe(map(objetoContadores => {
        return objetoContadores;
      }),
        catchError((error, captura) => {
          console.log(error);
          throw error;
        })
      );
  }

  cargarListadoDocumentos(
    IDdoc: number,
    usuarioActual: string,
    principalSecundario: string,
    numFactura: string,
    tipoDocumento: number,
    estadoDocumento: number,
    desdeFecha: number,
    hastaFecha: number,
    valorUsuarioDIEZ: number,
    valorFechaFACTURA: number,
    valorEmpresaNombre: string,
    valorImporteFACTURA: number,
    valorTieneIncidencia: boolean
  ): Observable<DocPendientesDigitalizar[]> {

    if (!usuarioActual) { usuarioActual = "vacio" }
    if (!principalSecundario) { principalSecundario = "vacio" }
    if (!valorEmpresaNombre) { valorEmpresaNombre = "vacio" }
    if (!numFactura) { numFactura = "vacio" } else {

      //  numFactura = btoa(numFactura);
      numFactura = btoa(unescape(encodeURIComponent(numFactura)));
    }

    var storageUser = JSON.parse(localStorage.getItem(this.storageKey));
    var usuariosExcluir: string = (storageUser.ignorarCliente != null && storageUser.ignorarCliente != undefined && storageUser.ignorarCliente != "" && storageUser.ignorarCliente != " ") ? storageUser.ignorarCliente : "vacio";

    return this.http.get<any>(`${environment.apiUri}api/documents/documentosPendDigitalizar/${usuariosExcluir}/${IDdoc}/${usuarioActual}/${principalSecundario}/${numFactura}/${desdeFecha}/${hastaFecha}/${valorFechaFACTURA}/${valorUsuarioDIEZ}/${valorEmpresaNombre}/${valorImporteFACTURA}/${valorTieneIncidencia}/${tipoDocumento}/${estadoDocumento}`);
  }

  cargarDocSeleccionadoDeHIJOaPADRE(user: string, idDocumento: string): Observable<Document> {

    return this.http.get<any>(`${environment.apiUri}api/documents/cargarDocSeleccionado/${user}/${idDocumento}`)
      .pipe(map(invoice => {
        return invoice;
      }),
        catchError((error, captura) => {

          console.warn(error);
          return null;
        })
      );
  }

  obtenerDatosDocSelecc(idDocumento: number): Observable<any> {

    return this.http.get<any>(`${environment.apiUri}api/documents/obtenerDatosDocSelecc/${idDocumento}`)
      .pipe(map(datos => {

        return datos;
      }),
        catchError((error, captura) => {

          console.log(error);
          return null;
        })
      );
  }

  updateDatosDocProcesado(esSupervisor: boolean, invoice: Invoice, observacionesINTERNAS: string, revisando: boolean): Observable<Invoice> {

    let header = new HttpHeaders({ 'content-type': 'application/json' });

    return this.http.put<any>(`${environment.apiUri}api/documents/updateDatosDocProcesado`, { invoice, observacionesINTERNAS, esSupervisor, revisando }, { headers: header })
      .pipe(map(respuestaUpdate => {

        return respuestaUpdate;
      }), catchError(this.handleErrorPutDocProcesado));
  }

  private handleErrorPutDocProcesado(err: HttpErrorResponse) {

    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {

      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      switch (err.status) {
        case 400:
        case 401:
        case 402:
        case 403:
        case 404:
          errorMessage = 'No se han encontrado los datos del documento a actualizar.';
          break;
        case 405:
        case 500:
        case 501:
        case 502:
        case 503:
        case 504:
        case 505:
          errorMessage = 'Ocurrió un error al grabar la información del documento.';
          break;
        default:
          errorMessage = `Error: ${err.status}, mensaje: ${err.message}`;
          break;
      }
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }

  comprobarPaginasAlCargar(document: Document): Observable<number> {

    let header = new HttpHeaders({ 'content-type': 'application/json' });

    return this.http.post<any>(`${environment.apiUri}api/documents/comprobarPaginasAlCargar`, document, { headers: header })
      .pipe(map(numPaginas => {

        return numPaginas;
      }),
        catchError((error, captura) => {

          console.log(error);
          //return null;
          throw error;
        })
      );
  }

  obtenerNifSecundario(codigoSecundario: string): Observable<string> {

    return this.http.get<any>(`${environment.apiUri}api/Companies/obtenerNifSecundario/${codigoSecundario}`)
      .pipe(map(nif => {

        return nif;
      }),
        catchError((error, captura) => {
          console.log(error);

          return null;
        })
      );
  }

  obtenerNombreSec(codigoSecundario: string): Observable<string> {

    let header = new HttpHeaders({ 'content-type': 'application/json' });

    return this.http.get<string>(`${environment.apiUri}api/Companies/obtenerNombreSec/${codigoSecundario}`, { headers: header, responseType: 'text' as 'json' });
    //.pipe(map(datos => {

    //  return datos;
    //}),
    //  catchError((error, captura) => {
    //    console.log(error);

    //    return null;
    //  })
    //);
  }

  obtenerNombrePrin(codigoPrincipal: string): Observable<string> {

    let header = new HttpHeaders({ 'content-type': 'application/json' });

    return this.http.get<string>(`${environment.apiUri}api/Companies/obtenerNombrePrin/${codigoPrincipal}`, { headers: header, responseType: 'text' as 'json' });
    //.pipe(catchError(this.handleError(HttpErr)));
    //.pipe(map(datos => {

    //  return datos;
    //}),
    //  catchError((error, captura) => {
    //    console.log(error);

    //    return null;
    //  })
    //);
  }

  quitarFacturaActual(idDocumento: number, usuarioQueLaProceso: string): Observable<boolean> {

    usuarioQueLaProceso = btoa(usuarioQueLaProceso);

    return this.http.get<any>(`${environment.apiUri}api/documents/quitarFacturaActual/${idDocumento}/${usuarioQueLaProceso}`)
      .pipe(map(seQuito => {

        return seQuito;
      }),
        catchError((error, captura) => {
          console.log(error);

          return null;
        })
      );
  }

  obtenerUltimoNifDeUserActual(usuarioSdm: string): Observable<string> {

    let header = new HttpHeaders({ 'content-type': 'application/json' });

    return this.http.get<any>(`${environment.apiUri}api/documents/obtenerUltimoNifDeUserActual/${usuarioSdm}`, { headers: header, responseType: 'text' as 'json' });

  }

  cargarUltimasEmpresasBuscador(usuarioSDM: string): Observable<Company[]> {

    if (!usuarioSDM) {
      return;
    }

    return this.http.get<any>(`${environment.apiUri}api/companies/obtenerUltimasEmpresasUsuario/${usuarioSDM}/5`)
      .pipe(map(datos => {

        return datos;
      }),
        catchError((error, captura) => {

          console.log(error);
          return null;
        })
      );
  }

  obtenerListadoEmpresasConNifName(nombreNifEmpresa: string): Observable<Company[]> {

    if (!nombreNifEmpresa) {

      return;
    }

    return this.http.get<any>(`${environment.apiUri}api/companies/obtenerListadoEmpresasConNifName/${nombreNifEmpresa}`)
      .pipe(map(datos => {

        return datos;
      }),
        catchError((error, captura) => {

          console.log(error);
          return null;
        })
      );
  }

  obtenerDatosFacturaCONnumFact(numFactura: string): Observable<Invoice> {

    //numFactura = btoa(numFactura);
    numFactura = btoa(unescape(encodeURIComponent(numFactura)));

    return this.http.get<any>(`${environment.apiUri}api/documents/obtenerDatosFacturaCONnumFact/${numFactura}`)
      .pipe(map(datos => {

        return datos;
      }),
        catchError((error, captura) => {

          console.log(error);
          return null;
        })
      );
  }

  obtenerEstadoDocPorID(IDdocumento: number): Observable<number> {

    return this.http.get<any>(`${environment.apiUri}api/documents/obtenerEstadoDocPorID/${IDdocumento}`)
      .pipe(map(estadoDoc => {

        return estadoDoc;
      }),
        catchError((error, captura) => {
          console.log(error);

          return null;
        })
      );
  }

  cambiarAestadoRevisandoDesdeLista(IDdocumento: number): Observable<Document> {

    return this.http.put<any>(`${environment.apiUri}api/documents/cambiarAestadoRevisandoDesdeLista/${IDdocumento}`, {})
      .pipe(map(estadoDoc => {

        return estadoDoc;
      }),
        catchError((error, captura) => {
          console.log(error);

          return null;
        })
      );
  }

  obtenerDatosPredicciones(idDocumento: number): Observable<PredictionsObj> {

    return this.http.get<any>(`${environment.apiUri}api/documents/obtenerDatosPredicciones/${idDocumento}`)
      .pipe(map(datos => {

        return datos;
      }),
        catchError((error, captura) => {

          console.log(error);
          //return null;
          throw error;
        })
      );
  }

  PrediccionCifPropioEncontrado(idDocumento: number): Observable<boolean> {
    return this.http.get<boolean>(`${environment.apiUri}api/documents/prediccionCifPropioEncontrado/${idDocumento}`);
  }

  cargarNombresSecundariosPrincipales(listadoDigitalizar: any[]): Observable<FiltroDocsResult[]> {

    let header = new HttpHeaders({ 'content-type': 'application/json' });

    return this.http.post<any>(`${environment.apiUri}api/documents/cargarNombresSecundariosPrincipales`, listadoDigitalizar, { headers: header })
      .pipe(map(docs => {
        return docs;
      }),
        catchError((error, captura) => {

          console.warn(error);
          return null;
        })
      );
  }

  obtenerUsuariosDIEZinvoicer(): Observable<UsuarioDIEZdesplegable[]> {

    return this.http.get<UsuarioDIEZdesplegable[]>(`${environment.apiUri}api/documents/ObtenerListadoUsuariosDiezInvoicer`);
  }

  obtenerUsuariosDeGrupo(miGrupo: number): Observable<UsuarioDIEZdesplegable[]> {

    return this.http.get<any[]>(`${environment.apiUri}api/documents/ObtenerUsuariosDeGrupo/${miGrupo}`);
  }

  ////////////////////////////////////////////
  //llamada a metodo de DIEZSCAN TERCEROS


  documentoDeTerceros(principal: string): Observable<ConsultaTercerosInvoicer> {

    return this.http.get<any>(`${environment.apiUri}api/documents/DocumentoDeTerceros/${principal}`);
  }

  ObtenerTerceros(): Observable<string[]> {

    return this.http.get<any>(`${environment.apiUri}api/users/ObtenerTerceros`);
  }

  alterarPaginasDoc(idDoc: number, numPag: number): Observable<boolean> {

    return this.http.get<any>(`${environment.apiUri}api/documents/AlterarPaginasDoc/${idDoc}/${numPag}`);
  }

  ////////////////////////////////////////////

  public ObtenerListadoDocumentosPendientes(usuario: string, fechaIni: number, fechaFin: number): Observable<any[]> {

    var storageUser = JSON.parse(localStorage.getItem(this.storageKey));
    var usuariosExcluir: string = (storageUser.ignorarCliente != null && storageUser.ignorarCliente != undefined && storageUser.ignorarCliente != "" && storageUser.ignorarCliente != " ") ? storageUser.ignorarCliente : "vacio";

    return this.GetQuery(`documents/obtenerListadoPendientesPrinSec/${usuariosExcluir}/${fechaIni}/${fechaFin}/${usuario}`);
  }

  public ObtenerNombresPrincSec(principal: string, secundario: string): Observable<any> {
    return this.GetQuery(`documents/ObtenerNombresPrinSecListadoRevision/${principal}/${secundario}`)
  }

  public ObtenerDetalleDocumentos(principal: string, secundario: string, fechaIni: number, fechaFin: number): Observable<PendingDocument[]> {

    return this.GetQuery(`documents/obtenerDetalleDocumentos/${principal}/${secundario}/${fechaIni}/${fechaFin}`);
  }

  public SepararDocumento(idDoc: number): Observable<any> {

    var usuario = JSON.parse(localStorage.getItem(this.storageKey)).email;
    //return this.GetQuery(`documents/separarDocumento/${idDoc}/${usuario}`);

    //return this.http.get<any>(`https://apisend-20-pr-as-fc-pre.azurewebsites.net/upload/separarDocumento/${idDoc}/${usuario}`);
    return this.http.get<any>(`https://apisend-20-pr-as-fc.azurewebsites.net/upload/separarDocumento/${idDoc}/${usuario}`);
    //return this.http.get<any>(`https://localhost:44304/upload/separarDocumento/${idDoc}/${usuario}`);
  }

  public ObtenerIdDocumentos(secundario: string, listaNombresDocs: string[]): Observable<number[]> {

    let header = new HttpHeaders({ 'content-type': 'application/json' });

    return this.http.post<any>(`${environment.apiUri}api/documents/obtenerIdDocumentos/${secundario}`, listaNombresDocs, { headers: header });
  }

  public DevolverDocumento(idDoc: number): Observable<boolean> {

    return this.GetQuery(`documents/devolverDocumento/${idDoc}`);
  }

  public BorraDocumento(idDoc: number): Observable<boolean> {

    return this.GetQuery(`documents/borraDocumento/${idDoc}`);
  }

  public EnviarARevision(idDoc: number): Observable<boolean> {
    return this.GetQuery(`documents/enviarARevision/${idDoc}`);
  }

  public CargarDoc(idDoc: number): Observable<Document> {

    return this.GetQuery(`documents/cargarDoc/${idDoc}`);
  }

  public ObtenerNumeroPaginas(idDoc: number): Observable<number> {

    return this.GetQuery(`documents/obtenerNumeroPaginasPorDocDetalle/${idDoc}`);
  }

  public EsFacturaDuplicada(secundario: string, tipoDocumento: number, cif: string, numeroFactura: string, idDocumento: number, fechaDocumento: number): Observable<boolean> {

    let numFacturaBTOA = btoa(numeroFactura);

    return this.GetQuery(`documents/comprobacionFacturaExist/false/${secundario}/${tipoDocumento}/${cif}/${numFacturaBTOA}/${idDocumento}/${fechaDocumento}`)
      .pipe(map(documento => {
        if (documento) {
          return true;
        }

        return false;
      }));
  }

  public MarcarComoDisponibles(listaDocs: any[]): Observable<boolean> {

    let header = new HttpHeaders({ 'content-type': 'application/json' });

    return this.http.post<boolean>(`${environment.apiUri}api/documents/PasarAdisponiblesEnPantalla`, listaDocs, { headers: header });
  }

  public ModificarFechaDocumentos(listaDocs: number[], fecha: number, hora: number): Observable<boolean> {

    let header = new HttpHeaders({ 'content-type': 'application/json' });

    let ruta: string = `${environment.apiUri}api/documents/modificarFecha/${fecha}/${hora}`;

    return this.http.post<boolean>(ruta, listaDocs, { headers: header });
  }

  public ObtenerNumeroFacturasPorNIF(nif: string, tipoDocumento: number): Observable<number> {

    return this.GetQuery(`documents/ObtenerNumeroFacturasPorNIF/${nif}/${tipoDocumento}`);
  }

  public ObtenerNumeroFacturasPorNIFPendientes(nif: string, tipoDocumento: number, secundario: string) {
    return this.GetQuery(`documents/ObtenerNumeroFacturasPorNIFPendientes/${nif}/${tipoDocumento}/${secundario}`);
  }

  public ObtenerObservacionSecundario(secundario: string, principal: string): Observable<any> {

    // secundario = "B3731";
    // principal = "R2297";
    return this.GetQuery(`documents/obtenerObservacionSecundario/${secundario}/${principal}`);
  }

  public RegistrarObservacionSecundario(objeto: ObservacionesSecundario): Observable<boolean> {

    let header = new HttpHeaders({ 'content-type': 'application/json' });
    let ruta: string = `${environment.apiUri}api/documents/registrarObservacionSecundario`;

    // objeto.secundario = "B3731";
    // objeto.usuario = "R2297";

    return this.http.post<boolean>(ruta, objeto, { headers: header });
  }

  ObtenerPoblacion(codigoPostal: string) {

    return this.http.get(`${environment.apiUri}api/companies/poblacion/${codigoPostal}`, { responseType: 'text' });
  }

  CargarListadoSecundariosPendientes(tipoDocumento: number, estadoDocumento: number, secundario: string): Observable<ListaFiltroSecunPrin[]> {

    var storageUser = JSON.parse(localStorage.getItem(this.storageKey));
    var usuariosExcluir: string = (storageUser.ignorarCliente != null && storageUser.ignorarCliente != undefined && storageUser.ignorarCliente != "" && storageUser.ignorarCliente != " ") ? storageUser.ignorarCliente : "vacio";

    return this.http.get<any>(`${environment.apiUri}api/documents/secundariosPendientes/${storageUser.email}/${usuariosExcluir}/${tipoDocumento}/${estadoDocumento}/${secundario}`);
  }

  CargarListadoPrincipalesPendientes(tipoDocumento: number, estadoDocumento: number, principal: string): Observable<ListaFiltroSecunPrin[]> {

    var storageUser = JSON.parse(localStorage.getItem(this.storageKey));
    var usuariosExcluir: string = (storageUser.ignorarCliente != null && storageUser.ignorarCliente != undefined && storageUser.ignorarCliente != "" && storageUser.ignorarCliente != " ") ? storageUser.ignorarCliente : "vacio";

    return this.http.get<any>(`${environment.apiUri}api/documents/principalesPendientes/${storageUser.email}/${usuariosExcluir}/${tipoDocumento}/${estadoDocumento}/${principal}`);
  }

  /////////////////
  //INVOFOX

  UpdateInvofoxDOC(idDocumento: number): Observable<any> {

    let header = new HttpHeaders({ 'content-type': 'application/json' });


    return this.http.put<any>(`https://apiinvofox-10-pr-as-fc-beta.azurewebsites.net/api/Invoices/update/${idDocumento}`, {}, { headers: header });
    //return this.http.put<any>(`https://apiinvofox-10-pr-as-fc.azurewebsites.net/api/Invoices/update/${idDocumento}`, {}, { headers: header });
    //return this.http.put<any>(`https://apiinvofox-10-pr-as-fc-pre.azurewebsites.net/api/Invoices/update/${idDocumento}`, {}, { headers: header });
    //return this.http.put<any>(`https://localhost:7252/api/Invoices/update/${idDocumento}`, {}, { headers: header });
  }
}
